module.exports = __webpack_public_path__ + "static/img/032电力公司使用手册.4314d0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/032电力公司使用手册.jpg
// module id = X8Cj
// module chunks = 0